<template>
    <Container class="sk-c-box">
        <template v-slot:header v-if="$slots.header || title">
            <div :class="headClass">
                <slot name="header" v-if="$slots.header"> </slot>
                <h2 v-if="!$slots.header">{{ title }}</h2>
            </div>
        </template>
        <slot></slot>
    </Container>
</template>

<script>
import Container from "./Container.vue";
export default {
    name: "Card",
    components: {
        Container,
    },
    props: {
        title: { type: String, default: "" },
        noBorder: { type: Boolean, default: true },
    },
    computed: {
        headClass() {
            return "ly-c-card-header" + (this.noBorder ? "" : " sk-border-bottom");
        },
    },
};
</script>
